import { getCategories } from "./config";

export default class ProgramCollector{
    constructor(){
        this.blocks = {}
        this.reloadBlockConfig()
        this.onWSXMLChange = this.onWSXMLChange.bind(this)
    }

    reloadBlockConfig(){
        const categories = getCategories()
        categories.forEach(category => {
            category.blocks.forEach(block => {
                this.blocks[block.name] = block.constructor
            });
        });
    }

    onWSXMLChange(xml){
        this.xml = xml
    }

    getProgramXML(){
        return this.xml
    }

    getProgramAST(){
        let topLevelASTNodes = []
        
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(this.xml,"text/xml")
        const topLevelNodes = xmlDoc.childNodes[0].childNodes
        for (let i = 0; i < topLevelNodes.length; i++) {
            const node = topLevelNodes[i];
            // create AST for top level nodes
            let ASTNode = this.getASTForBlock(node)
            // discard orphan nodes
            if(ASTNode.TOP_LEVEL){
                topLevelASTNodes.push(ASTNode)
            }
        }
        console.log(`${topLevelASTNodes.length} Top-Level-AST-Blocks detected!`)
        console.log(topLevelASTNodes)
        return topLevelASTNodes
    }

    getASTForBlock(block){
        const type = block.attributes.type.nodeValue
        const childNodes = block.childNodes
        let ASTBlock = new this.blocks[type]()
        for (let i = 0; i < childNodes.length; i++) {
            const child = childNodes[i];
            switch (child.nodeName) {
                case "next":
                    ASTBlock.next = this.getASTForBlock(child.firstChild)
                    break;
                case "value":
                    const value_name = child.attributes.name.nodeValue
                    ASTBlock.values[value_name] = this.getASTForBlock(child.firstChild)
                    break;
                case "statement":
                    const statement_name = child.attributes.name.nodeValue
                    ASTBlock.statements[statement_name] = this.getASTForBlock(child.firstChild)
                    break;
                case "field":
                    const field_name = child.attributes.name.nodeValue
                    ASTBlock.fields[field_name] = child.textContent
                    break;
                default:
                    break;
            }
            
        }
        

        return ASTBlock

    }
}